<template>
  <div>
    <Breadcrumbs
      :paths="['/' + get_prefix() + 'user', $route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.common.user") }}{{ $t("message.common.any_regist") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-card class="pa-5 mt-1">
      <IdpSelect
        :path="get_prefix() + 'organization/idp'"
        :auto_load="true"
        v-on:update_iid="iid = $event"
      ></IdpSelect>
      <v-text-field
        :label="$t('message.common.user') + $t('message.common.any_name')"
        v-model="user"
        :rules="[
          v => (v && v.length <= 80) || $t('message.common.over_text', { length: 80 }),
          v => /^[a-z0-9_.+-]+@[a-z0-9-]+\.[a-z0-9-.]+$/.test(v) || $t('message.common.invalid_email')
        ]"
        counter="80"
      >
      </v-text-field>
      <v-select
        :label="$t('message.common.role')"
        :items="roles"
        item-text="label"
        item-value="value"
        v-model="role"
      >
        <template v-slot:item="props">
          {{ $t('message.common.role_' + props.item.label) }}
        </template>
        <template v-slot:selection="props">
          <v-list-item class="pa-2 pl-0" style="min-height:auto">
            {{ $t('message.common.role_' + props.item.label) }}
          </v-list-item>
        </template>
      </v-select>
      <GeneralSelect
        :mode="mode"
        :label="$t('message.common.target')"
        layer_type="layer"
        :target_layer="['group']"
        :target="target"
        v-on:update_target="target = $event"
        v-on:clear_target="reset_target($event)"
      >
      </GeneralSelect>
      <template v-if="domains.length > 1">
        <v-select
          :label="$t('message.common.domain')"
          :items="domains"
          item-text="label"
          item-value="value"
          v-model="domain"
          :rules="[
            v => (v && v.length >= 1) || $t('message.common.select_one')
          ]"
          multiple
        >
        </v-select>
      </template>
      <template v-if="purposes.length > 1">
        <v-select
          :label="$t('message.common.purpose')"
          :items="purposes"
          item-text="label"
          item-value="value"
          v-model="purpose"
          :rules="[
            v => (v && v.length >= 1) || $t('message.common.select_one')
          ]"
          multiple
        >
        </v-select>
      </template>
      <v-select
        :label="$t('message.common.option')"
        :items="options"
        item-text="label"
        item-value="value"
        v-model="option"
        :rules="[
          valid_options
        ]"
        multiple
      >
      </v-select>
      <v-card class="pa-5" v-if="$store.getters.rozetta_idp.indexOf(iid) !== -1">
        {{ $t('message.common.idp_link') }}
        <v-text-field
          :label="$t('message.user.firstName')"
          v-model="firstName"
          :rules="[
            v => (v && v.length <= 40) || $t('message.common.over_text', { length: 40 })
          ]"
          counter="40"
        >
        </v-text-field>
        <v-text-field
          :label="$t('message.user.lastName')"
          v-model="lastName"
          :rules="[
            v => (v && v.length <= 40) || $t('message.common.over_text', { length: 40 })
          ]"
          counter="40"
        >
        </v-text-field>
        <template v-if="firstName.length > 0 || lastName.length > 0">
          {{ $t("message.user.display_name", { firstName: firstName, lastName: lastName }) }}
        </template>
        <v-text-field
          :label="$t('message.user.password')"
          v-model="password"
          type="password"
          :rules="[
            v => (v && v.length <= 40) || $t('message.common.over_text', { length: 40 }),
            v => /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,40}$/.test(v) || $t('message.common.invalid_password')
          ]"
          counter="40"
        >
        </v-text-field>
      </v-card>
      <p class="text-right mt-5 mb-0">
        <v-btn
          color="primary"
          :disabled="!registable || executing"
          @click="pre_regist_data()"
        >
          {{ $t("message.common.regist") }}
        </v-btn>
        <v-btn :to="get_prev(get_prefix() + 'user')">
          {{ $t("message.common.prev") }}
        </v-btn>
      </p>
    </v-card>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import IdpSelect from '../components/IdpSelect';
import GeneralSelect from '../components/GeneralSelect';
import { res_regist } from "../js/res_regist";
import { http_error } from "../js/http_error";

export default {
  name: 'user_regist',
  components: {
    Breadcrumbs,
    IdpSelect,
    GeneralSelect
  },
  mixins: [res_regist, http_error],
  props: {
    mode: String
  },
  data: function(){
    return {
      module_id: "36",
      nav_path: null,
      executing: false,
      iid: "",
      user: "",
      role: "user",
      domain: [],
      purpose: [],
      option: [],
      allowed_domains: [],
      allowed_purposes: [],
      allowed_options: [],
      firstName: "",
      lastName: "",
      password: "",
      parameters: {
      },
      target: {
        layer: "",
        did: "",
        aid: "",
        nid: "",
        gid: "",
        uid: ""
      },
      allowed_options_spec: {
        "develop": {},
        "in-company": {},
        "option1": {
          valid_domains: ["t-3mt"]
        },
        "option2": {
          valid_domains: ["t-3mt"]
        }
      }
    }
  },
  methods: {
    pre_regist_data: function(){
      this.parameters = {
        iid: this.iid,
        user: this.user,
        gid: this.target.gid,
        role: this.role,
        allowed_domains: this.domain,
        allowed_purposes: this.purpose,
        allowed_options: this.option
      };
      if(this.$store.getters.rozetta_idp.indexOf(this.iid) === -1){
        this.regist_data(this.get_prefix() + "user", "", "user");
      }else{
        // IdP連携
        this.parameters.firstName = this.firstName;
        this.parameters.lastName = this.lastName;
        this.parameters.password = this.password;
        this.regist_data(this.get_prefix() + "rozetta_user", "", "user");
      }
    },
    update_nid: function(){
      this.$http.get(this.$store.getters.api_endpoint + "/" + this.mode + "/organization")
        .then( response => {
          if(this.$store.getters.debug){
            console.log("response.data:" + JSON.stringify(response.data));
          }
          this.allowed_domains = response.data.allowed_domains;
          this.allowed_purposes = response.data.allowed_purposes;
          this.allowed_options = Array.isArray(response.data.allowed_options) ? response.data.allowed_options : [];
          this.domain = [];
          if(this.allowed_domains.length === 1){
            this.domain = [
              this.allowed_domains[0]
            ];
          }
          this.purpose = [];
          if(this.allowed_purposes.length === 1){
            this.purpose = [
              this.allowed_purposes[0]
            ];
          }
          this.option = [];
        })
        .catch( error => {
          if(this.http_error(error)){
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    }
  },
  mounted: function(){
    this.update_nid();
  },
  computed: {
    registable: function(){
      return this.iid !== ""
        && (this.user !== "" && this.user.length <= 80 && /.+@.+\..+/.test(this.user))
        && this.target.gid !== ""
        && (this.$store.getters.rozetta_idp.indexOf(this.iid) === -1
          || (this.firstName !== "" && this.firstName.length <= 40
            && this.lastName !== "" && this.lastName.length <= 40
            && this.password !== "" && this.password.length <= 40 && /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,40}$/.test(this.password)))
        && this.domain.length >= 1
        && this.purpose.length >= 1
        && this.valid_options === true;
    },
    roles: function(){
      var result = [];
      if(this.mode === "organization"){
        result.push({
          "label": "organization_manager",
          "value": "organization_manager"
        });
      }
      if(["organization", "group"].indexOf(this.mode) >= 0){
        result.push({
          "label": "group_manager",
          "value": "group_manager"
        });
      }
      result.push({
        "label": "user",
        "value": "user"
      });
      return result;
    },
    domains: function(){
      var domains = [];
      for(var domain of this.allowed_domains){
        domains.push({
          "label": this.$i18n.t('message.common.domain_' + domain),
          "value": domain
        });
      }
      return domains;
    },
    purposes: function(){
      var purposes = [];
      for(var purpose of this.allowed_purposes){
        purposes.push({
          "label": this.$i18n.t('message.common.purpose_' + purpose),
          "value": purpose
        });
      }
      return purposes;
    },
    options: function(){
      var options = [];
      for(var option of this.allowed_options){
        options.push({
          "label": this.$i18n.t('message.common.option_' + option),
          "value": option
        });
      }
      return options;
    },
    valid_options: function(){
      for(var option of this.option){
        if((option in this.allowed_options_spec)
          && ("valid_domains" in this.allowed_options_spec[option])
          && this.allowed_options_spec[option].valid_domains.filter(domain => this.domain.indexOf(domain) >= 0).length <= 0){
          return this.$i18n.t('message.common.select_domain', {
            domain: this.allowed_options_spec[option].valid_domains.map(domain => this.$i18n.t('message.common.domain_' + domain)).join(", ")
          });
        }
      }
      return true;
    }
  }
}
</script>
